// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__2rCCk","buttons":"PendingPaymentAlert_buttons__2NQZB"};